import { Constants } from "@shared";

export const HelpFooter = () => (
    <div className="flex flex-col gap-4">
        <div className="h-px bg-neutral-100 w-full" />
        <div className="flex flex-col gap-2 text-neutral-800">
            <p className="text-sm leading-5 tracking-[0.14px]">
                Visit our <a href={Constants.Help.FAQ} target="_blank" rel="noreferrer" className="text-blue-800 rounded focus-visible:outline-focus-ring">FAQ</a> for help, <a href={Constants.Help.AutoPay} target="_blank" rel="noreferrer" className="text-blue-800 rounded focus-visible:outline-focus-ring">Autopay guides</a>, and to contact support.
            </p>
            <p className="text-xs leading-4 tracking-[0.12px]">
                Bill notifications are sent to your email. Your dashboard is always up to date. Manage your payment settings in <a href="/myaccount" className="text-blue-800 rounded focus-visible:outline-focus-ring">Settings</a>.
            </p>
        </div>
    </div>
);
